import React, { Component } from 'react';
import { RootState } from './reducers/RootReducer';
import { setStateEditData, setStateManagerData } from './action/StateManagerAction';
import { setDiamondAvailable, setDiamondDetailsSuccess, setInitialDiamondOption } from './action/DiamondAction';
import { setExpandedRow, setPagination, setTableInitialState } from './action/TableAction';
import {
  setExclusionOption,
  setInitialOption,
  setJourney,
  setRingExtraData,
  setRingOptions,
  setRingPrice,
  setSelectedRingDetails
} from './action/RingAction';
import {
  setFooterToggle,
  setInitialFooter,
  setIsShowCartPage,
  setIsShowFooter,
  setStyleID
} from './action/FooterAction';
import { resetFilters, setAfterRingOptions, setFilter } from './action/FilterAction';
import { connect, ConnectedProps } from 'react-redux';
import RouteManager from './RouteManager';
import Loader from './components/Loader/Loader';
import ComponentManger from './ComponentManger';
import {
  setFilterMinMaxProperty,
  setInitialStartWithSettingData,
  setMaximumCaratSize,
  setSelectedProduct,
  setStartWithSettingFilter
} from './action/StartWithSettingFilterAction';
import {
  setDiamondTabIconTrue,
  setHeaderTabDefault,
  setHeaderTabToSetting,
  setPreviousURLPath
} from './action/HeaderAction';
import { setOrderIsExisting } from './action/CartAction';
import { getLocalStorageData } from "./Utils/general";
import { deserializeFilterOptions, serializeFilterOptions } from "./Utils/filtersUrl";
import CONSTANTS from "./constant/general";

const mapStateToProps = (state: RootState) => ({
  stateManagerData: state.stateManager,
  diamond:          state.diamond,
  footer:           state.footer,
  cart:             state.cart
});

const mapDispatchToProps = {
  setStateManagerData,
  setDiamondDetailsSuccess,
  setExpandedRow,
  setRingOptions,
  setSelectedRingDetails,
  setFilter,
  setIsShowFooter,
  setIsShowCartPage,
  setStartWithSettingFilter,
  setStyleID,
  setFilterMinMaxProperty,
  setRingPrice,
  setStateEditData,
  setDiamondAvailable,
  setRingExtraData,
  setInitialStartWithSettingData,
  setInitialOption,
  setInitialDiamondOption,
  resetFilters,
  setTableInitialState,
  setInitialFooter,
  setPreviousURLPath,
  setExclusionOption,
  setPagination,
  setAfterRingOptions,
  setFooterToggle,
  setHeaderTabDefault,
  setDiamondTabIconTrue,
  setHeaderTabToSetting,
  setSelectedProduct,
  setMaximumCaratSize,
  setOrderIsExisting,
  setJourney
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromStateManagerRedux = ConnectedProps<typeof connector>;
type PropsFromComponent = {
  data: {
    app: any;
  };
  changeScreen?: (data: { viewName: string; id: string }) => void;
};

interface ScreenManagerState {
  instanceData: {
    screenManager: ScreenManager;
  };
  previousPath: string;
  styleId: string | null;
}

class ScreenManager extends Component<PropsFromStateManagerRedux & PropsFromComponent, ScreenManagerState> {

  constructor(props: PropsFromStateManagerRedux & PropsFromComponent) {
    super(props);
    this.state = {
      instanceData: { screenManager: this },
      previousPath: '',
      styleId:      ''
    };
  }

  urlUpdate(url: string, replace = false): void {
    if (replace) {
      window.history.replaceState({}, '', `#${url}`);
      return;
    }
    window.history.pushState({}, '', `#${url}`);
  }

  /*changeScreen = (data: { viewName: string | undefined;styleId?:string|null, id?: string; uuid?: string, params?:{[key:string]: string} }, type?: string | undefined): void => {
    this.setState({...this.state,previousPath:data.viewName as string,styleId: data.styleId || null})
    let fullPath;
    const buildParam = {...(data.params ?? {}) && data.params};
    switch (data.viewName){
      case CONSTANTS.BUILD:
        fullPath = `${data.viewName}${data.styleId ? `/styleId=${data.styleId}${(buildParam && Object.keys(buildParam).length > 0) ? `&${new URLSearchParams(buildParam)}` : ''}` : ''}${data.id ? `/diamondId=${data.id}` : ''}`;

        break;
      case CONSTANTS.EDIT:
        fullPath = `summary${buildParam ? `${(buildParam && Object.keys(buildParam).length > 0) ? `?${new URLSearchParams(buildParam)}` : ''}` : ''}`;
        break;
      case 'dyo':
      case 'setting':
        const item = {...(data.params ?? {}) && data.params};
        fullPath = `${data.viewName}${data.styleId ? `/styleId=${data.styleId}${(item && Object.keys(item).length > 0) ? `&${new URLSearchParams(item)}` : ''}` : ''}${data.id ? `/diamondId=${data.id}` : ''}`;
        break;
      case 'stud-earrings':
        const items = {...(data.params ?? {}) && data.params};
        fullPath = `${data.viewName}${data.styleId ? `/styleId=${data.styleId}${(items && Object.keys(items).length > 0) ? `&${new URLSearchParams(items)}` : ''}` : ''}`;
        break;

      case 'details':
        fullPath = `${data.viewName}/diamondId=${data.id}`;
        break;
      default:
        fullPath = `${data.viewName}${buildParam ? `${(buildParam && Object.keys(buildParam).length > 0) ? `?${new URLSearchParams(buildParam)}` : ''}` : ''}`;
    }
    if(type !== 'popstate'){
      this.urlUpdate(fullPath as string);
    }
    const path = RouteManager.findPath(`#${data.viewName}`, !!data.styleId);

    const managerData = {
      path,
      id: data.id || ''
    }
    Object.entries(managerData).forEach(([key,value]) => this.props.setStateManagerData(key,value));
  };*/

  changeScreen = (
    data: {
      viewName: string | undefined;
      styleId?: string | null;
      id?: string;
      uuid?: string;
      params?: { [key: string]: string };
      searchParams?: { [key: string]: string };
    },
    type?: string
  ): void => {

    const { viewName, styleId = null, id, params = {}, searchParams = {} } = data;
    if (!viewName) return;

    this.setState(prev => ({
      ...prev,
      previousPath: viewName,
      styleId,
    }));
    const hasParams = Object.keys(params).length > 0;
    const queryParams = hasParams ? new URLSearchParams(params).toString() : '';
    const hasSearchParams = Object.keys(searchParams).length > 0;
    const querySearchParams = hasSearchParams ? new URLSearchParams(searchParams).toString() : '';
    let fullPath = '';
    switch (viewName) {
      case CONSTANTS.BUILD:
      case 'dyo':
      case 'setting':
      case 'stud-earrings':
        fullPath = `${viewName}`;
        if (styleId) fullPath += `/styleId=${styleId}`;
        if (hasParams) fullPath += `${styleId ? '&' : '/'}${queryParams}`;
        if (id) fullPath += `/diamondId=${id}`;
        if (hasSearchParams) fullPath += `?${querySearchParams}`;
        break;

      case CONSTANTS.EDIT:
        fullPath = `summary`;
        if (hasParams || hasSearchParams) {
          fullPath += `?${new URLSearchParams({ ...params, ...searchParams }).toString()}`;
        }
        break;

      case 'details':
        fullPath = `${viewName}/diamondId=${id}`;
        if (hasSearchParams) fullPath += `?${querySearchParams}`;
        break;

      default:
        fullPath = viewName;
        if (hasParams || hasSearchParams) {
          fullPath += `?${new URLSearchParams({ ...params, ...searchParams }).toString()}`;
        }
        break;
    }

    if (type !== 'popstate') {
      this.urlUpdate(fullPath, type === 'initial');
    }

    const path = RouteManager.findPath(`#${viewName}`, !!styleId);
    const managerData = {
      path,
      id: id || '',
    };

    for (const [ key, value ] of Object.entries(managerData)) {
      this.props.setStateManagerData(key, value);
    }
  };

  componentDidMount(): void {
    this.handleUrlChange();
    this.props.setPreviousURLPath(document.referrer);
    localStorage.setItem('previousPath', JSON.stringify(document.referrer));
    window.addEventListener('popstate', this.handleUrlChange);
  }

  componentWillUnmount(): void {
    window.removeEventListener('popstate', this.handleUrlChange);
  }

  shouldComponentUpdate(prevProps: PropsFromStateManagerRedux): boolean {
    return prevProps.stateManagerData.options.path !== this.props.stateManagerData.options.path;
  }

  parseURL(url: string): { command: string; params: { [key: string]: string } } {
    const fragment = url?.split('#')[1];
    if (!fragment) {
      // this.changeScreen({ viewName: 'home' });
      return { command: 'home', params: { command: CONSTANTS.BUILD, rpid: "000000" } };
    }
    const questionMarkIndex = fragment.indexOf('?');
    const pathPart = questionMarkIndex === -1 ? fragment : fragment.slice(0, questionMarkIndex);
    const queryPart = questionMarkIndex === -1 ? '' : fragment.slice(questionMarkIndex + 1);
    const command = pathPart.split('/').find(Boolean) || '';

    const queryString = [ queryPart, ...pathPart.split('/').slice(1) ]
      .filter(Boolean)
      .join('&')
      // tolerate a stray extra `?` used as a separator instead of `&` (e.g. malformed/hand-built links)
      .replace(/\?/g, '&');

    const params: { [key: string]: string } = {};

    for (const pair of queryString.split('&')) {
      if (!pair) continue;
      const [ key, ...rest ] = pair.split('=');
      if (key) params[key] = decodeURIComponent(rest.join('=') ?? '');
    }
    return { command, params };
  }

  getSKU = async (uuid: string) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_GET_DESIGN_DATA}?hkuuid=${uuid}&page_size=200`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();

      if (!result) return;
      const {
        pricing_data,
        inventoryAvailabilities = {},
        category,
        is_order_exist,
        diamond_details,
        journey,
        sku,
        ring_extra_data = {},
        setting_filter_options = {},
        diamond_filter_options = {},
        ring_options_code = {},
        setting_details = {},
        table_row_id = {},
      } = result;
      const {
        left_band_retail_price,
        right_band_retail_price,
        ring_retail_price,
        band_tcw,
        ring_tcw,
      } = pricing_data || {};
      const { available = null, page_number = 0 } = inventoryAvailabilities;
      const { options = {}, afterRingSelectedOptions = {} } = diamond_filter_options || {};
      if (category !== CONSTANTS.STUD_CATEGORY_CODE) {
        this.props.setOrderIsExisting(is_order_exist);

        if (available || is_order_exist) {
          this.props.setDiamondDetailsSuccess(diamond_details);
        }

        this.props.setIsShowFooter(true);
        this.props.setJourney(journey);

        const priceRange = setting_filter_options?.Setting_Price;
        if (priceRange && priceRange.includes("-")) {
          const [ min, max ] = priceRange.split("-").map(Number);
          if (!isNaN(min) && !isNaN(max)) {
            this.props.setFilterMinMaxProperty({ Setting_Price: { min, max } });
          }
        }

        this.props.setAfterRingOptions(afterRingSelectedOptions);
        this.props.setDiamondAvailable(available);
        this.props.setPagination(0, { pageSize: 200, pageIndex: page_number });
      }

      const { exclusionOption, ...extraData } = ring_extra_data || {};
      this.props.setRingExtraData(extraData);
      this.props.setExclusionOption(exclusionOption);

      this.props.setStateEditData(result);
      this.props.setStyleID(sku?.split('-')[0] ?? "");

      this.props.setRingPrice({
        ring_price:       ring_retail_price,
        left_band_price:  left_band_retail_price,
        right_band_price: right_band_retail_price,
        bands_tcw:        band_tcw,
        ring_tcw:         ring_tcw,
      });
      const { selectedProduct, maximumCaratSize } = setting_filter_options;
      this.props.setMaximumCaratSize(maximumCaratSize);
      this.props.setSelectedProduct(selectedProduct);

      const assignments: Array<[ Record<string, any>, Function ]> = [
        [ ring_options_code, this.props.setRingOptions ],
        [ setting_details, this.props.setSelectedRingDetails ],
        [ setting_filter_options, this.props.setStartWithSettingFilter ],
      ];

      if (category !== CONSTANTS.STUD_CATEGORY_CODE) {
        assignments.push(
          [ options, this.props.setFilter ],
          [ table_row_id, this.props.setExpandedRow ]
        );
      }

      for (const [ obj, setter ] of assignments) {
        if (!obj || typeof setter !== "function") continue;

        Object.entries(obj).forEach(([ key, value ]) => {
          setter(
            setter === this.props.setExpandedRow ? Number(key) : key,
            value as string
          );
        });
      }

      return result;
    } catch (e) {
      console.log(e)
    }
  }
  handleUrlChange = async (e?: PopStateEvent): Promise<void> => {
    try {
      const parsedData = this.parseURL(window.location.href as string);
      const { command, params } = parsedData;
      const navType = e?.type ?? 'initial';
      const updatedCommand = params.command || command;
      let restoredFilterParams: Record<string, string> = {};
      if (command === 'setting' || command === 'stud-earrings') {
        const restoredSettingFilters = deserializeFilterOptions(params, 'setting');
        Object.entries(restoredSettingFilters).forEach(([ k, v ]) => this.props.setStartWithSettingFilter(k, v as string | string[]));
        restoredFilterParams = serializeFilterOptions(restoredSettingFilters, 'setting');
      } else if (command === 'diamond') {
        const restoredDiamondFilters = deserializeFilterOptions(params, 'diamond');
        Object.entries(restoredDiamondFilters).forEach(([ k, v ]) => this.props.setFilter(k, v as string | string[] | boolean));
        restoredFilterParams = serializeFilterOptions(restoredDiamondFilters, 'diamond');
      }
      let category = "";
      let {
        start_with,
        rpid,
        hkuuid:    uuid,
        diamondId: id,
        styleId,
        ring_style,
        shape,
        type,
        carat,
        crown,
        side,
        metal,
        crown_metal,
        size,
        band,
        uuid: hbuuid,
        side_stones,
        earring_back,
        diamond_quality,
        design_origin,
      } = params;
      const updatedRpid = params.rpid || rpid || "000000";
      const updatedUuid = params.design_uuid || uuid;
      const paramsObj = {
        ...(ring_style && { ring_style }),
        ...(shape && { shape }),
        ...(type && { type }),
        ...(carat && { carat }),
        ...(crown && { crown }),
        ...(side && { side }),
        ...(metal && { metal }),
        ...(crown_metal && { crown_metal }),
        ...(size && { size }),
        ...(side_stones && { side_stones }),
        ...(earring_back && { earring_back }),
        ...(diamond_quality && { diamond_quality }),
        // ...(band && {band})
      };
      const queryObj = {
        ...(updatedRpid && { rpid: updatedRpid }),
        ...(updatedCommand && { command: updatedCommand }),
        ...(updatedUuid && { design_uuid: updatedUuid }),
        ...(design_origin && { design_origin: design_origin }),
        ...restoredFilterParams
      }
      const viewName = start_with && [ 'diamond', 'setting', 'dyo' ].includes(start_with.toLowerCase())
        ? start_with.toLowerCase()
        : command;
      styleId = start_with && start_with.toLowerCase() === 'dyo' ? 'RB001' : styleId;
      if ([ CONSTANTS.BUILD, CONSTANTS.EDIT ].includes(updatedCommand)) {
        [ CONSTANTS.RPID, CONSTANTS.BUILDER_MODE_KEY, CONSTANTS.DESIGN_UUID ].forEach(key => localStorage.removeItem(key));
      }
      if (updatedUuid || getLocalStorageData(CONSTANTS.DESIGN_UUID)) {
        //@ts-ignore
        const result = await this.getSKU(updatedUuid || getLocalStorageData(CONSTANTS.DESIGN_UUID));
        styleId = result?.sku?.split('-')[0];
        id = result?.diamond_details?.id;
        category = result?.category;
      }
      if (e) {
        if (([ 'setting', 'diamond', 'details', 'stud-earrings' ].includes(command)) && this.state.styleId) {
          this.props.setInitialOption();
          if (command === 'diamond' && this.props.footer.toggle) {
            await this.props.setHeaderTabDefault();
          } else if (command === 'setting' && this.props.footer.toggle) {
            await this.props.setDiamondTabIconTrue('setting');
          } else if (command === 'stud-earrings' && this.props.footer.toggle) {
            await this.props.setDiamondTabIconTrue('stud-earrings');
          }
          if (command === 'setting' && params.styleId) {
            window.postMessage({ action: 'handshakeIFrame' });
          }
          this.props.setInitialFooter();
        } else if (command === 'diamond' && this.state.previousPath === 'setting') {
          this.props.setInitialStartWithSettingData();
        } else if (command === 'dyo' && this.state.previousPath === 'setting' && params.styleId) {
          this.props.setInitialOption();
          window.postMessage({ action: 'handshakeIFrame' });
        } else if ([ 'dyo', 'setting' ].includes(command) && styleId && this.state.previousPath === 'diamond') {
          if (this.props.footer.toggle) {
            this.props.setHeaderTabToSetting('dyo');
            this.props.setFooterToggle();
          }
          this.props.setInitialDiamondOption();
          this.props.setTableInitialState();
          this.props.resetFilters();
        } else if (command === 'diamond' && this.state.previousPath === 'details') {
          this.props.setInitialDiamondOption();
          this.props.footer.toggle && this.props.setFooterToggle();
          // this.props.setInitialFooter();
        }
      }

      if (command === CONSTANTS.BUILD) {
        this.changeScreen({
          viewName,
          uuid:         updatedUuid,
          id:           id,
          styleId,
          params:       paramsObj,
          searchParams: queryObj
        }, navType);
        this.props.setIsShowFooter(false);
      } else if ([ CONSTANTS.EDIT, "summary" ].includes(command)) {
        if (category !== CONSTANTS.STUD_CATEGORY_CODE) {
          if (this.props.diamond.isDiamondAvailable || this.props.cart.isOrderExist) {
            this.props.setIsShowCartPage();
            this.props.setIsShowFooter(true);
            this.changeScreen({ viewName: CONSTANTS.EDIT, params: paramsObj, searchParams: queryObj }, navType);
          } else {
            this.changeScreen({ viewName: 'diamond', params: paramsObj, searchParams: queryObj }, navType);
          }
        } else {
          this.changeScreen({ viewName: "stud-earrings", styleId, params: paramsObj, searchParams: queryObj }, navType);
        }
      } else {
        this.changeScreen({ viewName, id: id, uuid, styleId, params: paramsObj, searchParams: queryObj }, navType);
      }
      const sessionStorageObject = {
        [CONSTANTS.RPID]:             updatedRpid,
        [CONSTANTS.BUILDER_MODE_KEY]: updatedCommand,
        [CONSTANTS.DESIGN_UUID]:      updatedUuid,
        [CONSTANTS.HBUUID]:           hbuuid
      }
      if ([ CONSTANTS.BUILD, CONSTANTS.EDIT ].includes(updatedCommand)) {
        Object.entries(sessionStorageObject).forEach(([ key, value ]) => {
          if (value) {
            localStorage.setItem(key, JSON.stringify(value));
          } else {
            localStorage.removeItem(key);
          }
        })
      }/*else{
        Object.entries(sessionStorageObject).forEach(([key, value]) => (
            localStorage.removeItem(key)
        ))
      }*/
    } catch (error) {
      console.error('Error parsing URL:', error);
    }
  };

  render(): JSX.Element {
    const { stateManagerData: { options: { path } } } = this.props;
    let ViewComponent: any | null = null;
    if (path) {
      ViewComponent = ComponentManger.findComponent(path as string);
    }

    return (
      <React.Suspense fallback={<div style={{ height: '100vh' }}><Loader/></div>}>
        {ViewComponent && (
          //@ts-ignore
          <ViewComponent instanceData={this.state.instanceData}/>
        )}
      </React.Suspense>
    );
  }
}

export default connector(ScreenManager);
